export default __webpack_public_path__ + "static/media/plus_gray.eecf6ba0.svg";